let Y
let X
let oParent, oImg

let currObj // 调用这个js的vue

// 给对象添加放大和拖动监听事件
export function zoomAndDrag (tImg, vueObj) {
  oImg = document.getElementById(tImg)
  oParent = oImg.parentNode
  Y = oParent.offsetTop
  X = oParent.offsetLeft
  addEvent(oImg, 'mousedown', dragFunc) // addEvent 这个函数里面执行了批注初始化
  addWheelEvent(oImg, radioFunc)
  currObj = vueObj
}

export function suitToImgPan (panH, panW, imgH, imgW, imgid, hTab, wTab) {
  const hBlank = hTab // 高度空隙
  const wBlank = wTab // 宽度空隙
  panH = panH - hBlank * 2
  panW = panW - wBlank * 2
  let vWith = 0
  let vHeight = 0
  const wp = parseFloat(panH) / parseFloat(panW) // 大图框比例
  const wI = parseFloat(imgH) / parseFloat(imgW) // 实际图像比例
  if (wp > wI) {
    // 缩放到满足 Pan宽度100%
    vWith = panW
  } else {
    // 缩放到满足 Pan高度100%
    vWith = Math.round(panH / wI) // 浮点四舍五入
  }
  vHeight = Math.round(vWith * wI) // alert('pp:' + vWith + '-' + vHeight)
  const iobj = document.getElementById(imgid)
  const mtop = (panH - vHeight) / 2 + hBlank
  const mleft = (panW - vWith) / 2 + wBlank

  iobj.style.height = vHeight + 'px'
  iobj.style.width = vWith + 'px'
  iobj.style.top = mtop + 'px'
  iobj.style.left = mleft + 'px'

  const srcW = currObj.imgW
  const imgRatio = parseFloat(vWith) / parseFloat(srcW)
  currObj.imgRatio = imgRatio // 当前图与原始图的比例
  currObj.resetTopAndLeft(mleft, mtop)
  currObj.refreshNotes()
}

// 移除对象的放大和拖动监听事件
export function removezoomAndDrag (tImg) {
  oImg = document.getElementById(tImg)
  oParent = oImg.parentNode
  Y = oParent.offsetTop
  X = oParent.offsetLeft
}

function addEvent (obj, sType, fn) {
  if (obj.addEventListener) {
    obj.addEventListener(sType, fn, false)
  } else {
    obj.attachEvent('on' + sType, fn)
  }
}

// 拖动函数表达式
// 每次拖动的里面都有批注重新初始化
const dragFunc = function (ev) {
  const oEvent = prEvent(ev)
  const disX = oEvent.clientX - oImg.offsetLeft - X
  const disY = oEvent.clientY - oImg.offsetTop - Y

  // --------------------------------
  const isShowNotePan = currObj.penShow
  // eslint-disable-next-line no-debugger
  // debugger
  if (isShowNotePan) {
    oImg.className = 'onehand'
    currObj.penShow = false
    // eslint-disable-next-line no-debugger
    // debugger
    const mx = Math.round(oEvent.offsetX / currObj.imgRatio)
    const my = Math.round(oEvent.offsetY / currObj.imgRatio)
    currObj.initNoteAndFlag(mx, my)

    currObj.colseAddFlag() // 回到普通状态
    // alert(X + '----' + Y + '----------------' + disX + '--' + disY)
    return
  } else {
  }
  // ---------------------------------
  const startMove = function (ev) {
    currObj.showFlags = false
    if (oParent.setCapture) {
      oParent.setCapture()
    }
    const oEvent = ev || window.event
    const l = oEvent.clientX - disX - X
    const t = oEvent.clientY - disY - Y
    oImg.style.left = l + 'px'
    oImg.style.top = t + 'px'

    currObj.resetTopAndLeft(l, t)
    // VueObj.refreshNotes() // 刷新标签位置
    oParent.onselectstart = function () {
      return false
    }
  }
  const endMove = function (ev) {
    if (oParent.releaseCapture) {
      oParent.releaseCapture()
    }
    oParent.onselectstart = null
    removeEvent(oParent, 'mousemove', startMove)
    removeEvent(oParent, 'mouseup', endMove)
    currObj.refreshNotes()
  }
  addEvent(oParent, 'mousemove', startMove)
  addEvent(oParent, 'mouseup', endMove)
  return false
}

function removeEvent (obj, sType, fn) {
  if (obj.removeEventListener) {
    obj.removeEventListener(sType, fn, false)
  } else {
    obj.detachEvent('on' + sType, fn)
  }
}

function prEvent (ev) {
  const oEvent = ev || window.event
  if (oEvent.preventDefault) {
    oEvent.preventDefault()
  }
  return oEvent
}

let wheelFunc // 滑轮函数全局
// 添加滑轮事件
function addWheelEvent (obj, callback) {
  if (window.navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
    addEvent(obj, 'DOMMouseScroll', wheel)
  } else {
    addEvent(obj, 'mousewheel', wheel)
  }
  function wheel (ev) {
    const oEvent = prEvent(ev)
    const delta = oEvent.detail ? oEvent.detail > 0 : oEvent.wheelDelta < 0
    callback && callback.call(oEvent, delta)
    return false
  }
  wheelFunc = wheel
}
// 清除滑轮事件
// eslint-disable-next-line no-unused-vars
function removeWheelEvent (obj, callback) {
  if (window.navigator.userAgent.toLowerCase().indexOf('firefox') !== -1) {
    removeEvent(obj, 'DOMMouseScroll', wheelFunc)
  } else {
    removeEvent(obj, 'mousewheel', wheelFunc)
  }
}

// 移除拖拽和放缩动作监听
// eslint-disable-next-line no-redeclare
/*
function removezoomAndDrag (tImg) {
    oImg = document.getElementById(tImg)
    oParent = oImg.parentNode
    Y = oParent.offsetTop
    X = oParent.offsetLeft
    removeEvent(oImg, 'mousedown', dragFunc)
    removeWheelEvent(oImg, radioFunc)
}
*/
let zoomFlag = true
const radioFunc = function (delta) {
  if (zoomFlag) {
    zoomFlag = false
    zoomImage(delta)
    setTimeout(beginReady, 200)
  }
}

export function zoomImage (delta) {
  currObj.showFlags = false
  // let ratioL = (this.clientX - oImg.offsetLeft - X) / oImg.offsetWidth
  // let ratioT = (this.clientY - oImg.offsetTop - Y) / oImg.offsetHeight
  const ratioDelta = !delta ? 1 + 0.25 : 1 - 0.2
  // 滑轮滚动缩小放大

  const oldWidth = oImg.style.width
  const oldHeight = oImg.style.height

  // Math.round(5/2)  //四舍五入
  const w = parseFloat(oldWidth) * ratioDelta
  const h = parseFloat(oldHeight) * ratioDelta

  if (w < 100 || w > 10000) {
    zoomFlag = true
    return
  }
  oImg.style.width = w + 'px'
  oImg.style.height = h + 'px'
  let parentH = oParent.style.width

  let parentW = oParent.style.height
  if (parentH === '' || parentH === 0) {
    parentH = oParent.clientHeight
  }
  if (parentW === '' || parentW === 0) {
    parentW = oParent.clientWidth
  }

  const left = (parentW - w) / 2 - 1
  const top = (parentH - h) / 2 - 1
  oImg.style.left = left + 'px'
  oImg.style.top = top + 'px'

  // zoomFlag = true;
  // debugger
  const srcW = currObj.imgW
  const imgRatio = parseFloat(w) / parseFloat(srcW)
  currObj.imgRatio = imgRatio // 当前图与原始图的比例
  currObj.resetTopAndLeft(left, top)
  currObj.refreshNotes()
}

function beginReady () {
  zoomFlag = true
}
